import { supabase } from '../lib/supabaseClient';

export const logEvent = async (event_type, event_details = {}) => {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();
  console.log('logEvent function called with:', { event_type, event_details });
    const logEntry = {
      event_type,
      event_details,
      created_at: new Date().toISOString(),
    };

    if (user) {
      logEntry.user_id = user.id;
    } else {
      // You could store IP or browser fingerprint if needed (optional)
      logEntry.event_details = {
        ...event_details,
        guest: true,
      };
    }

    const { error } = await supabase.from('site_usage_logs').insert([logEntry]);

    if (error) {
      console.error('logEvent failed:', error.message);
    }
  } catch (err) {
    console.error('logEvent: unexpected error', err);
  }
};
